(function () {
	'use strict';

	angular.module('qbePortal').directive('qbValidExpiryDate', function () {
		var EXPIRY_DATE_REGEXP = /^([0-9]{2})\/([0-9]{2})$/;

		return {
			require: 'ngModel',
			restrict: '',
			link: function (scope, elm, attrs, ctrl) {
				// only apply the validator if ngModel is present and Angular has added the email validator
				if (ctrl) {

					// this will overwrite the default Angular email validator
					ctrl.$validators.invalidDate = function (modelValue) {
						return ctrl.$isEmpty(modelValue)
							|| (EXPIRY_DATE_REGEXP.test(ctrl.$viewValue) && validDate(ctrl.$viewValue));
					};
				}

				function validDate(modelValue) {
					var monthValue = parseInt(modelValue.match(EXPIRY_DATE_REGEXP)[1]),
						yearValue = parseInt(modelValue.match(EXPIRY_DATE_REGEXP)[2]);

					return monthValue > 0 && monthValue <= 12 && validYearAndMonth(monthValue, yearValue);
				}

				function validYearAndMonth(monthValue, yearValue) {
					var yearMonthConcat = yearValue * 100 + monthValue;
					return parseInt(moment().format('YYMM')) <= yearMonthConcat;
				}

			}
		};
	});
})();
